import { outlinedInputClasses } from '@mui/material';
import { experimental_extendTheme as materialExtendTheme } from '@mui/material/styles';

import { customColors } from './constants';
import { theme } from './theme';

export const materialTheme = materialExtendTheme({
  components: {
    MuiOutlinedInput: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          borderRadius: 3,
          fontFamily: 'inherit',
          // eslint-disable-next-line regex/invalid
          color: 'var(--joy-palette-text-primary)',

          [`& .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: customColors.ag.input.borderColor,
          },

          [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: customColors.ag.input.borderColor,
          },

          // eslint-disable-next-line max-len
          [`&.${outlinedInputClasses.focused}.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]:
            {
              borderColor: theme.palette.danger[500],
            },

          [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: theme.palette.focusVisible,
          },

          [`&.${outlinedInputClasses.sizeSmall}`]: {
            fontSize: 13,
            height: 32,
          },
        },
        input: {
          paddingLeft: '8px',
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          marginTop: '4px !important',
          marginBottom: '4px !important',
        },
      },
    },
  },
});
